












import Vue from 'vue'

export default class MarkupTableEmptyRow extends Vue {

}
